<template>
<validation-observer ref="EvaluationResultForm" class="form">
    <form ref="form" class="form">
        <validation-provider
        :name="$t('defination.evaluation_result.form.description')"
        :rules="{ required: true }"
        v-slot="validationContext"
        >
        <b-row>
            <b-col sm="4"> <label for="description"> {{$t('defination.evaluation_result.form.description')}} </label> </b-col>
            <b-col sm="8"> <b-form-input id="description" v-model="description" :placeholder="$t('defination.evaluation_result.formPlaceholder.description')" 
                :state="getValidationState(validationContext)"
                aria-describedby="live-feedback"
            />
                <b-form-invalid-feedback id="live-feedback">{{
                    validationContext.errors[0]
                }}</b-form-invalid-feedback>
            </b-col>
        </b-row>
        </validation-provider>

        <validation-provider
        :name="$t('defination.evaluation_result.form.rank')"
        :rules="{ required: true }"
        v-slot="validationContext"
        >
        <b-row>
        <b-col sm="4"> <label for="rank"> {{$t('defination.evaluation_result.form.rank')}} </label> </b-col>
          <b-col sm="8">
                <b-form-input
                    id="sb-small"
                    type="number"
                    :placeholder="$t('defination.evaluation_result.formPlaceholder.rank')"
                    class="mb-2"
                    v-model="rank"
                    :state="getValidationState(validationContext)"
                    aria-describedby="live-feedback">
                </b-form-input>
                <b-form-invalid-feedback id="live-feedback">{{
                        validationContext.errors[0]
                    }}
                </b-form-invalid-feedback>
        </b-col>
        </b-row>
        </validation-provider>
    </form>
</validation-observer>
</template>

<script>
    export default {
        name: "EvaluationResultForm",
        data(){
            return {
                description: this.data ? this.data.description : "",
                rank: this.data ? this.data.rank : null,
                errMsg: ""
            }
        },
        props: {
            data: Object,
            changeData: Function,
            save: Boolean,
            saveState: Function,
            modalName: String,
            modalEvent: Function
        },
        methods: {
        getValidationState({ dirty, validated, valid = null }) {
            return dirty || validated ? valid : null;
        },
        clearForm() {
            this.errMsg = "";
            this.description = "",
            this.rank = null
            this.modalEvent(false);
        }
      },
        watch: {
            save: async function(data) {
                if (data) {
                    this.$refs.EvaluationResultForm.validate().then(async success => {
                    if (success){
                    let val = {
                        description: this.description,
                        rank: parseInt(this.rank),
                    }
                    switch (this.modalName) {
                    case "add":
                        await this.$store.dispatch("addEvaluationResults", val);
                        break;
                    case "edit":
                        val.id = this.data.id;
                        await this.$store.dispatch("editEvaluationResults", val);
                        break;
                    }
                    if (this.$store.getters.getAddressStatus.status == "Success") {
                    this.$store.dispatch("listEvaluationResults");
                    this.clearForm();
                    } else {
                    this.errMsg = i18n.t("general.addErrMsg");
                    }
                    }
                    })
                    this.saveState(false);
                }
            }
        }
    }
</script>

<style lang="css" scoped > 
    @import "../styles/modalForm.min.css"; 
    @import "../styles/modal.min.css";
</style>


// WEBPACK FOOTER //
// src/pages/General/Defination/modals/EvaluationResultForm.vue